import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "user-types",
    title: "ประเภทผู้ใช้",
    summary:
      "ทุกบัญชีมีประเภทผู้ใช้หนึ่งประเภท (employee, customer, partner หรือประเภทที่สร้างเอง) ประเภทบอกว่าบัญชีนี้เป็นใคร ใช้กำหนดว่าเข้าแอปไหนได้ ใครสมัครเองได้ อีเมลโดเมนไหนได้ประเภทอะไร กฎ 2FA และกลุ่มที่บัญชีใหม่จะได้อัตโนมัติ",
    access:
      "เปิดดูได้เมื่อมีสิทธิ์ settings:read (owner, admin, auditor) · สร้าง แก้ไข และลบได้เมื่อมีสิทธิ์ settings:write (owner, admin) · การเปลี่ยนประเภทของผู้ใช้แต่ละคนทำที่หน้ารายละเอียดผู้ใช้ → แท็บ สิทธิ์เข้าถึง",
    shot: {
      file: "user-types-list.png",
      caption: "หน้าประเภทผู้ใช้: ประเภทที่มีในระบบ 3 ประเภทและประเภทที่สร้างเอง",
    },
    sections: [
      {
        id: "concept",
        heading: "ประเภทผู้ใช้คืออะไร",
        body: [
          'ประเภทผู้ใช้ตอบคำถามว่า "บัญชีนี้เป็นใคร" เช่น พนักงาน ลูกค้า หรือพาร์ทเนอร์ หนึ่งบัญชีมีได้ประเภทเดียว ต่างจากกลุ่ม (อยู่ได้หลายกลุ่ม) และบทบาท (สิทธิ์ในคอนโซลนี้)',
          "แต่ละแอปกำหนดว่าประเภทไหนเข้าได้ (หน้าแอป → แท็บ สิทธิ์เข้าถึง) แอปใหม่อนุญาตเฉพาะ employee โดยค่าเริ่มต้น ประเภทยังถูกส่งให้แอปใน token เป็น user_type",
          'บัญชีที่ผู้ดูแลสร้างโดยไม่ระบุประเภท และบัญชีเก่าที่สร้างก่อนมีฟีเจอร์นี้ ถือเป็น employee · บัญชีระบบ root ไม่มีประเภท (แสดงเป็น "บัญชีระบบ") และไม่ถูกนับในคอลัมน์จำนวนบัญชี',
        ],
      },
      {
        id: "built-in",
        heading: "ประเภทที่มีในระบบ",
        body: [
          'ประเภทที่มีป้าย "มีในระบบ" สร้างมาพร้อมระบบ แก้ไขชื่อ คำอธิบาย และนโยบายได้ แต่ลบไม่ได้ และเปลี่ยน ID ไม่ได้',
        ],
        fieldsTitle: "ประเภทที่มีในระบบ",
        fields: [
          {
            name: "employee",
            description:
              "พนักงานขององค์กร (ประเภทเริ่มต้น) ไม่เปิดให้สมัครเอง กฎ 2FA ตามนโยบายรวม · เป็นประเภทเดียวที่มีบทบาทคอนโซลได้และเข้าคอนโซลได้",
          },
          {
            name: "customer",
            description: "ลูกค้าที่ใช้แอปสำหรับลูกค้า เปิดให้สมัครเองได้ กฎ 2FA ไม่บังคับ",
          },
          {
            name: "partner",
            description: "พาร์ทเนอร์ภายนอกที่เข้าได้เฉพาะแอปที่เลือก ไม่เปิดให้สมัครเอง กฎ 2FA ตามนโยบายรวม",
          },
        ],
      },
      {
        id: "list",
        heading: "ตารางประเภทผู้ใช้",
        body: ['ด้านบนตารางมีคำอธิบายสั้น ๆ ปุ่ม "โหลดใหม่" และปุ่ม "สร้างประเภทผู้ใช้"'],
        fieldsTitle: "คอลัมน์ในตาราง",
        fields: [
          { name: "ชื่อ", description: 'ชื่อประเภท ป้าย "มีในระบบ" (ถ้ามี) และ ID ตัวเล็กด้านล่าง' },
          { name: "จำนวนบัญชี", description: "จำนวนบัญชีที่เป็นประเภทนี้ในตอนนี้" },
          { name: "สมัครเองได้ (self sign-up)", description: '"ใช่" (จุดสีเขียว) หรือ "ไม่ใช่"' },
          { name: "Email domains", description: 'โดเมนอีเมลที่ผูกกับประเภทนี้ หรือ "ไม่มี"' },
          { name: "กฎ 2FA", description: '"ตามนโยบายรวม (inherit)", "ไม่บังคับ" หรือ "บังคับ"' },
          { name: "กลุ่มเริ่มต้น", description: 'ID ของกลุ่มที่บัญชีใหม่จะได้อัตโนมัติ หรือ "ไม่มี"' },
          {
            name: 'ปุ่ม "แก้ไข" / "ลบ"',
            description: 'เห็นเฉพาะผู้มีสิทธิ์ settings:write · ประเภทที่มีในระบบไม่มีปุ่ม "ลบ"',
          },
        ],
      },
      {
        id: "form",
        heading: "ช่องในหน้าต่างสร้าง/แก้ไขประเภทผู้ใช้",
        shot: { file: "user-types-edit-dialog.png", caption: "หน้าต่างแก้ไขประเภทผู้ใช้ employee" },
        fields: [
          {
            name: "ID",
            required: true,
            description:
              "รหัสถาวร 2–41 ตัวอักษร ขึ้นต้นด้วยตัวพิมพ์เล็ก ตามด้วย a–z, 0–9, - หรือ _ เช่น contractor (ตัวพิมพ์ใหญ่ถูกแปลงให้) ถูกส่งใน token จึง เปลี่ยนภายหลังไม่ได้ ต้องไม่ซ้ำ",
          },
          {
            name: "ชื่อ",
            description:
              "ชื่อที่อ่านง่าย ไม่เกิน 100 ตัวอักษร ตอนสร้างเว้นว่างได้ (ใช้ ID แทน) ตอนแก้ไขเป็นช่องบังคับ",
          },
          { name: "คำอธิบาย", description: "ไม่บังคับ ไม่เกิน 500 ตัวอักษร" },
          {
            name: "สมัครเองได้ (self sign-up)",
            description:
              'ถ้าเปิด ผู้เข้าชมสร้างบัญชีประเภทนี้เองได้ แต่ต้องสมัครผ่านแอปที่ตั้ง "อนุญาตให้สมัครเป็น" ประเภทนี้ไว้ และต้องเปิด "อนุญาตให้สมัครสมาชิกเอง" ในหน้าวิธีเข้าสู่ระบบด้วย',
          },
          {
            name: "Email domains",
            description:
              'บรรทัดละหนึ่งโดเมน ผู้ที่สมัครเอง (หรือเข้าด้วย Google/Microsoft ครั้งแรก) ด้วยอีเมลโดเมนนี้จะได้ประเภทนี้ทันที โดยไม่ต้องเปิด "สมัครเองได้" · example.com = ตรงโดเมนนี้เท่านั้น · *.example.com = เฉพาะ sub-domain เช่น th.example.com (ไม่รวม example.com) · รูปแบบไม่ถูกต้องจะมีข้อความผิดพลาดใต้ช่อง',
          },
          {
            name: "กฎ 2FA",
            description:
              '"ตามนโยบายรวม (inherit)" = ใช้นโยบาย MFA ในหน้าวิธีเข้าสู่ระบบ · "ไม่บังคับ" = ไม่บังคับเลย แม้นโยบายรวมจะบังคับ · "บังคับ" = ต้องตั้ง 2FA ก่อนเข้าแอปใด ๆ',
          },
          {
            name: "กลุ่มเริ่มต้น",
            description:
              "เลือกกลุ่มได้หลายกลุ่ม (มีช่องค้นหา) บัญชีใหม่ของประเภทนี้จะเข้ากลุ่มเหล่านี้อัตโนมัติ ทั้งตอนสมัครเอง เข้าด้วย Google/Microsoft ครั้งแรก และตอนผู้ดูแลเพิ่มผู้ใช้ ไม่มีผลกับบัญชีที่มีอยู่แล้ว",
          },
        ],
        fieldsTitle: "ช่องในหน้าต่าง",
      },
      {
        id: "sign-up-rules",
        heading: "ระบบเลือกประเภทให้ผู้สมัครอย่างไร",
        body: [
          "เมื่อมีคนสมัครเอง ระบบเลือกประเภทก่อนสร้างบัญชี ตามลำดับนี้:",
          "1) ถ้าอีเมลตรงกับ Email domains ของประเภทใด จะได้ประเภทนั้น (ตรวจประเภทที่มีในระบบก่อน) — นี่เป็นวิธีเดียวที่การสมัครเองจะได้ประเภท employee",
          '2) ถ้าไม่ตรง จะใช้ประเภทที่แอปที่ใช้สมัครตั้งไว้ใน "อนุญาตให้สมัครเป็น" โดยประเภทนั้นต้องเปิด "สมัครเองได้"',
          "3) ถ้าไม่เข้าข้อใดเลย การสมัครจะถูกปฏิเสธ ไม่มีใครได้เป็น employee โดยอัตโนมัติ",
        ],
        tips: [
          "ตัวอย่าง: ใส่ company.co.th ใน Email domains ของ employee พนักงานที่สมัครด้วยอีเมลบริษัทจะได้เป็น employee ส่วนคนอื่นที่สมัครผ่านแอปลูกค้าจะได้เป็น customer",
        ],
      },
      {
        id: "create",
        heading: "สร้างประเภทผู้ใช้",
        steps: [
          'กด "สร้างประเภทผู้ใช้" ที่มุมขวาบนของตาราง',
          'กรอก ID (ปุ่ม "บันทึก" กดได้เมื่อ ID ถูกรูปแบบ) ชื่อ และคำอธิบาย',
          "ตั้งนโยบาย: สมัครเองได้, Email domains, กฎ 2FA, กลุ่มเริ่มต้น",
          'กด "บันทึก" — ระบบแสดง "บันทึกแล้ว"',
          "ไปที่หน้าแอปที่ต้องการ → แท็บ สิทธิ์เข้าถึง เพื่ออนุญาตประเภทใหม่นี้ (ถ้ายังไม่อนุญาต บัญชีประเภทนี้จะเข้าแอปที่จำกัดสิทธิ์ไม่ได้)",
        ],
        tips: [
          "ตัวอย่างประเภทที่สร้างเอง: contractor (ผู้รับเหมา), intern (นักศึกษาฝึกงาน), vendor (ผู้ขาย)",
        ],
      },
      {
        id: "edit",
        heading: "แก้ไขประเภทผู้ใช้",
        steps: [
          'กด "แก้ไข" ในแถวของประเภท (แก้ได้ทั้งประเภทที่มีในระบบและที่สร้างเอง)',
          'หน้าต่าง "แก้ไขประเภทผู้ใช้ <ชื่อ>" เปิดขึ้น ID แก้ไม่ได้',
          'แก้ชื่อ คำอธิบาย หรือนโยบาย แล้วกด "บันทึก"',
        ],
        warnings: [
          'การเปลี่ยนกฎ 2FA เป็น "บังคับ" ทำให้ทุกบัญชีของประเภทนี้ที่ยังไม่มี 2FA ต้องตั้งค่าในการเข้าแอปครั้งถัดไป',
          "การเพิ่ม Email domains ของ employee ทำให้ใครก็ตามที่มีอีเมลโดเมนนั้นสมัครเป็นพนักงานได้ (เมื่อเปิดการสมัครเอง) ใส่เฉพาะโดเมนที่องค์กรควบคุมได้จริงเท่านั้น",
          'การปิด "สมัครเองได้" ทำให้แอปที่ตั้ง "อนุญาตให้สมัครเป็น" ประเภทนี้รับสมัครไม่ได้อีก (การสมัครด้วย Email domains ยังทำงาน)',
          "การแก้ Email domains และกลุ่มเริ่มต้นมีผลกับบัญชีใหม่เท่านั้น ไม่เปลี่ยนประเภทหรือกลุ่มของบัญชีที่มีอยู่",
        ],
      },
      {
        id: "delete",
        heading: "ลบประเภทผู้ใช้",
        shot: { file: "user-types-delete-dialog.png", caption: "หน้าต่างยืนยันการลบประเภทผู้ใช้" },
        steps: [
          'กด "ลบ" ในแถวของประเภทที่สร้างเอง',
          'หน้าต่างถาม "ลบประเภทผู้ใช้ <ชื่อ>? จะลบไม่ได้ถ้ายังมีบัญชีหรือแอปใช้อยู่"',
          'กด "ลบ" เพื่อยืนยัน',
        ],
        warnings: [
          'ลบได้เฉพาะเมื่อไม่มีบัญชีเป็นประเภทนี้ (คอลัมน์จำนวนบัญชีเป็น 0) และไม่มีแอปใดอนุญาตหรือใช้ประเภทนี้สำหรับการสมัคร มิฉะนั้นจะมีข้อความผิดพลาดในหน้าต่าง ให้ย้ายผู้ใช้ไปประเภทอื่น (หน้าผู้ใช้ → แท็บ สิทธิ์เข้าถึง → "เปลี่ยนประเภท") และแก้สิทธิ์เข้าถึงของแอปก่อน',
          "ประเภทที่มีในระบบ (employee, customer, partner) ลบไม่ได้",
        ],
      },
      {
        id: "change-user-type",
        heading: "เปลี่ยนประเภทของผู้ใช้",
        body: ['ทำที่หน้ารายละเอียดผู้ใช้ → แท็บ สิทธิ์เข้าถึง → "เปลี่ยนประเภท" (ต้องมีสิทธิ์ users:write)'],
        warnings: [
          "เมื่อเปลี่ยนประเภท token ของผู้ใช้ที่แอปซึ่งเขาไม่มีสิทธิ์แล้วจะถูกเพิกถอนทันที",
          "ผู้ใช้ที่มีบทบาทคอนโซลอยู่ เปลี่ยนประเภทไม่ได้ ต้องเอาบทบาทออกก่อน",
        ],
      },
    ],
    related: ["groups", "sign-in-method", "client-detail", "user-detail", "roles"],
  },
  en: {
    id: "user-types",
    title: "User types",
    summary:
      "Every account has exactly one user type (employee, customer, partner or a custom type). The type says who the account is and drives which applications it can use, who may sign up, which email domains map to which type, the 2FA rule and the groups new accounts join automatically.",
    access:
      "Viewing needs settings:read (owner, admin, auditor). Creating, editing and deleting needs settings:write (owner, admin). A particular user's type is changed on the user's page → Access tab.",
    shot: {
      file: "user-types-list.png",
      caption: "The User types page: three built-in types and a custom type",
    },
    sections: [
      {
        id: "concept",
        heading: "What a user type is",
        body: [
          'A user type answers "who is this account?" — an employee, a customer, a partner. Each account has exactly one, unlike groups (many per account) and roles (permissions in this console).',
          "Each application decides which types may sign in (application page → Access tab); new applications allow employees only by default. The type is also sent to applications in tokens as user_type.",
          'Accounts created by an admin without choosing a type, and old accounts from before this feature, are employees. The root system account has no type (shown as "System account") and is not counted in the Accounts column.',
        ],
      },
      {
        id: "built-in",
        heading: "Built-in types",
        body: [
          'Types with the "Built-in" badge come with the system. Their name, description and policy can be edited, but they cannot be deleted and their ID cannot change.',
        ],
        fieldsTitle: "Built-in types",
        fields: [
          {
            name: "employee",
            description:
              "Staff of the organisation (the default type). No self sign-up; 2FA follows the global policy. The only type that can hold console roles and use the console.",
          },
          {
            name: "customer",
            description: "Customers of customer-facing applications. Self sign-up allowed; 2FA optional.",
          },
          {
            name: "partner",
            description:
              "External partners with access to selected applications. No self sign-up; 2FA follows the global policy.",
          },
        ],
      },
      {
        id: "list",
        heading: "The user types table",
        body: ['Above the table: a short explanation, a "Reload" button and "Create user type".'],
        fieldsTitle: "Columns in the table",
        fields: [
          {
            name: "Name",
            description: 'The type\'s name, a "Built-in" badge if applicable, and its ID underneath.',
          },
          { name: "Accounts", description: "How many accounts currently have this type." },
          { name: "Self sign-up", description: '"Yes" (green dot) or "No".' },
          { name: "Email domains", description: 'Email domains mapped to this type, or "None".' },
          { name: "Two-factor rule", description: '"Inherit global policy", "Optional" or "Required".' },
          {
            name: "Default groups",
            description: 'IDs of the groups new accounts join automatically, or "None".',
          },
          {
            name: '"Edit" / "Delete" buttons',
            description: 'Only with settings:write. Built-in types have no "Delete" button.',
          },
        ],
      },
      {
        id: "form",
        heading: "Fields in the create/edit window",
        shot: { file: "user-types-edit-dialog.png", caption: "The Edit user type window for employee" },
        fieldsTitle: "Fields in the window",
        fields: [
          {
            name: "ID",
            required: true,
            description:
              "Permanent ID: 2–41 characters, a lowercase letter first, then a–z, 0–9, - or _, e.g. contractor (capitals are lower-cased). Sent in tokens, so it cannot be changed later; must be unique.",
          },
          {
            name: "Name",
            description:
              "Readable name, up to 100 characters. Optional when creating (the ID is used), required when editing.",
          },
          { name: "Description", description: "Optional, up to 500 characters." },
          {
            name: "Self sign-up",
            description:
              'When on, visitors can create an account of this type themselves — but only through an application whose "Allow sign-up as" is set to this type, and only when "Allow users to sign up" is on in Sign-in method.',
          },
          {
            name: "Email domains",
            description:
              "One per line. People who sign up (or sign in with Google/Microsoft for the first time) with an email of this domain get this type, even if Self sign-up is off. example.com = exactly that domain. *.example.com = sub-domains only, e.g. th.example.com (not example.com itself). Invalid entries show an error under the box.",
          },
          {
            name: "Two-factor rule",
            description:
              '"Inherit global policy" = the MFA policy on the Sign-in method page. "Optional" = never forced, even if the global policy would. "Required" = 2FA must be set up before using any application.',
          },
          {
            name: "Default groups",
            description:
              "Pick any number of groups (searchable). New accounts of this type join them automatically — on self sign-up, first Google/Microsoft sign-in and when an admin adds the user. Existing accounts are not affected.",
          },
        ],
      },
      {
        id: "sign-up-rules",
        heading: "How a new sign-up gets its type",
        body: [
          "When someone signs up themselves, the type is chosen before the account is created, in this order:",
          "1) If the email matches a type's Email domains, they get that type (built-in types are checked first). This is the only way a self sign-up becomes an employee.",
          '2) Otherwise, the type set in "Allow sign-up as" of the application they sign up through, provided that type has Self sign-up on.',
          "3) Otherwise the sign-up is refused. Nobody becomes an employee by default.",
        ],
        tips: [
          "Example: put company.co.th in employee's Email domains. Staff signing up with the company email become employees; others signing up through the customer app become customers.",
        ],
      },
      {
        id: "create",
        heading: "Create a user type",
        steps: [
          'Click "Create user type" at the top right of the table.',
          'Enter the ID ("Save" becomes clickable once it is valid), a name and a description.',
          "Set the policy: Self sign-up, Email domains, Two-factor rule, Default groups.",
          'Click "Save" — "Saved" appears.',
          "Open the applications concerned → Access tab and allow the new type (until then, accounts of this type cannot sign in to restricted applications).",
        ],
        tips: ["Examples of custom types: contractor, intern, vendor."],
      },
      {
        id: "edit",
        heading: "Edit a user type",
        steps: [
          'Click "Edit" in the type\'s row (built-in and custom types can both be edited).',
          'The "Edit user type <name>" window opens; the ID cannot be changed.',
          'Change the name, description or policy and click "Save".',
        ],
        warnings: [
          'Setting the Two-factor rule to "Required" makes every account of this type without 2FA set it up the next time they open an application.',
          "Adding Email domains to employee lets anyone with an address at that domain sign up as staff (when self sign-up is on). Only add domains your organisation really controls.",
          'Turning Self sign-up off stops sign-up through applications that offer "Allow sign-up as" this type (Email-domain sign-ups still work).',
          "Changes to Email domains and Default groups affect new accounts only; existing accounts keep their type and groups.",
        ],
      },
      {
        id: "delete",
        heading: "Delete a user type",
        shot: { file: "user-types-delete-dialog.png", caption: "The delete-user-type confirmation" },
        steps: [
          'Click "Delete" in a custom type\'s row.',
          'The window asks "Delete user type <name>? This is refused while accounts or applications still use it."',
          'Click "Delete" to confirm.',
        ],
        warnings: [
          'Deleting works only when no account has the type (Accounts = 0) and no application allows it or uses it for sign-up; otherwise an error appears in the window. Move the users to another type first (user page → Access tab → "Change type") and update the applications\' access.',
          "Built-in types (employee, customer, partner) cannot be deleted.",
        ],
      },
      {
        id: "change-user-type",
        heading: "Changing a user's type",
        body: ['Done on the user\'s page → Access tab → "Change type" (needs users:write).'],
        warnings: [
          "Changing the type immediately revokes the user's tokens at applications they can no longer use.",
          "A user who holds console roles cannot have their type changed; remove the roles first.",
        ],
      },
    ],
    related: ["groups", "sign-in-method", "client-detail", "user-detail", "roles"],
  },
};

export default topic;
